import { useEffect, useState } from "react";

export default function useLoadingEffect(fetchData: () => Promise<any>) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [responseData, setResponseData] = useState(null);
  const [fetch, setFetch] = useState(false);

  useEffect(() => {
    async function loadData() {
      if (!fetch) {
        return;
      }

      setIsLoading(true);

      const response = await fetchData();

      setResponseData(response);
      setIsLoading(false);
    }

    loadData();
  }, [fetch]);

  return [isLoading, responseData, setFetch];
}
